export default __webpack_public_path__ + "resources/icons/d332-ea0c.png";